export default [
  {
    path: `/credito`,
    name: `credito`,
    component: () => import("./AppCreditoView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: `/limite-credito`,
  //   name: `limite-credito`,
  //   component: () => import("./AppLimiteCreditoView.vue"),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
];
